import React, { useState, useEffect } from "react";
import Spinner from "../../reusables/spinner";
import InputField from "../../reusables/input";
import { motion } from "framer-motion";
import { update_site_details, get_settings } from "../../../redux/actions/adminActions";
import { connect } from "react-redux";
import {
  animationValues,
  transitionValues,
} from "../../../utils/pageTransitions";
import Toggle from "../../reusables/toggleBtn";

function SiteDetails({ updateSiteDetails, settings, accessToken, getSettings }) {
  const [formData, setData] = useState({
    site_title: settings?.site_title,
    site_url: settings?.site_url,
    site_email_address: settings?.site_email_address,
    admin_email_address: settings?.admin_email_address,
    site_address: settings?.site_address,
    time_zone: settings?.time_zone,
    stop_orders: settings?.stop_orders,
  });

  const [isLoading, setIsLoading] = useState(false);

  const handleChange = (e) => {
    setData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const toggleActivate = () => {
    setData({
      ...formData,
      stop_orders: "1",
    });
  };

  const toggleDeactivate = () => {
    setData({
      ...formData,
      stop_orders: "0",
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setIsLoading(true);
    updateSiteDetails(formData, accessToken, () => {
      getSettings(accessToken, () => {
        setIsLoading(false);
      });
    });
  };

  useEffect(() => {
    if (settings) {
      setData({
        site_title: settings?.site_title,
        site_url: settings?.site_url,
        site_email_address: settings?.site_email_address,
        admin_email_address: settings?.admin_email_address,
        site_address: settings?.site_address,
        time_zone: settings?.time_zone,
        stop_orders: settings?.stop_orders,
      });
    }
  }, [settings]);

  return (
    <motion.div
      initial="out"
      animate="in"
      exit="out"
      variants={animationValues}
      transition={transitionValues}
    >
      <div className="sectionHeight--mid">
        <div className="row">
          <div className="col-lg-7">
            <form className="py-3 px-2" onSubmit={handleSubmit}>
              <div className="mt-3 mb-3">
                <InputField
                  label="Site Title"
                  name="site_title"
                  value={formData?.site_title}
                  onChange={handleChange}
                />
              </div>

              <div className="mt-3 mb-3">
                <InputField
                  label="Site URL"
                  name="site_url"
                  value={formData?.site_url}
                  onChange={handleChange}
                />
              </div>

              <div className="mt-3 mb-3">
                <InputField
                  label="Site Email Address *"
                  name="site_email_address"
                  type="email"
                  value={formData?.site_email_address}
                  onChange={handleChange}
                />
              </div>

              <div className="mt-3 mb-3">
                <InputField
                  label="Admin Support Email Address *"
                  name="admin_email_address"
                  type="email"
                  value={formData?.admin_email_address}
                  onChange={handleChange}
                />
              </div>

              <div className="mt-3 mb-3">
                <InputField
                  label="Site Address"
                  name="site_address"
                  value={formData?.site_address}
                  onChange={handleChange}
                />
              </div>

              <div className="mt-3 mb-3">
                <InputField
                  label="Time Zone"
                  name="time_zone"
                  value={formData?.time_zone}
                  onChange={handleChange}
                />
              </div>

              <div className="pb-3">
                <p className="pb-1 textIsGray sectionText--small">Offline</p>

                <div className="alignOnly">
                  <p className="sectionText mb-0">Stop Orders</p>

                  <div className="mx-2">
                    <Toggle
                      value={formData?.stop_orders == "1" ? true : false}
                      activate={toggleActivate}
                      deactivate={toggleDeactivate}
                    />
                  </div>
                </div>
              </div>

              <div className="mt-4">
                {isLoading ? (
                  <button className="btn__filled textIsBold alignOnly" disabled>
                    Please Wait {""}
                    <Spinner />
                  </button>
                ) : (
                  <button className="btn__filled textIsBold">
                    Save Changes
                  </button>
                )}
              </div>
            </form>
          </div>
        </div>
      </div>
    </motion.div>
  );
}

const mapStateToProps = (state) => ({
  settings: state.admin.settings,
  accessToken: state.admin.token,
});

const mapDispatchToProps = (dispatch) => ({
  updateSiteDetails: (data, token, success) =>
    dispatch(update_site_details(data, token, success)),
  getSettings: (token, success) => dispatch(get_settings(token, success)),
});

export default connect(mapStateToProps, mapDispatchToProps)(SiteDetails);
